module.exports = __webpack_public_path__ + "static/media/left.4ec70687.png";